// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"9":"Contact","274":"Home","450":"About","549":"Policy","756":"Events"}[chunkId] || chunkId) + "." + {"9":"96603fb0","101":"b629311b","167":"5604676e","274":"d3b6c367","344":"e9bf5f01","450":"eeb38ab8","549":"13e7194b","756":"25d096cd"}[chunkId] + ".chunk.js";
};